import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  url: string;
}

interface NavigationPage { title: string; link: string; }

@Component({
  selector: 'app-assurance-decennale-construction',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-decennale-construction.component.html',
  styleUrls: ['./assurance-decennale-construction.component.scss']
})
export class AssuranceDecennaleConstructionComponent {
  title = 'Assurance Décennale Construction';
  subtitle = 'Responsabilité décennale obligatoire pour les professionnels du bâtiment';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/images/hero-decennale.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', url: '' },
    { label: 'Assurance Décennale Construction', url: '' }
  ];

  prevPage: NavigationPage = { title: 'Assurance Multirisque Immeuble Pro', link: '/entreprises/assurance-multirisque-immeuble-pro'
  };

  nextPage: NavigationPage = { title: 'Assurance Dommages-Ouvrage Maître', link: '/entreprises/assurance-dommages-ouvrage-maitre'
  };
}
